goog.provide('yext.storm.powerlistingstatus');
/**
 * Power Listing Status
 *
 * Power listing status functionality. Makes API calls to build panel and
 * updates it based upon the location selected. Also swaps between the status
 * panels for a specific location - synced, processing and unavailable
 *
 * TODO(mattjs) The status panels are fetched by ajax but are returning HTML, so
 * this module is tied to the DOM often. Breaking it from the DOM requires
 * centralizing how listing.brand.smallIconClass() is generated (a view helper)
 * so that the class name for the brand icon can be returned as part of a JSON
 * response
 */

goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectify');
goog.require('yext.storm.routesDEPRECATED');

var {Spinner} = /** @type {SpinnerJS} */ (require('spin.js'));
require('spin.js/spin.css');

var contextualHelpOptions = {
  event: 'hover',
  interactive: true,
  customClass: 'flat-tooltip',
  fade: true,
};

/**
 * Power Listing Status constructor
 * @constructor
 *
 * Assigns elements that are used globally and calls methods to bind events
 * related to the power listing panel
 */
var PowerListingStatus = function(locationId, showBuySubscriptionButton, showLocationSelector) {
  this.locationId = locationId;
  this.showBuySubscriptionButton = showBuySubscriptionButton;
  this.showLocationSelector = showLocationSelector;

  this.loadListingPanel(this.locationId);
};
goog.exportSymbol('PowerListingStatus', PowerListingStatus);

/**
 * After getting content from AJAX call, populate own variables
 */
PowerListingStatus.prototype.onLoadListingPanelComplete = function(html) {
  var $listingReport = $('#listing-report');
  $listingReport.html(html);

  // Loader for power listing status, uses spin.min.js
  this.spinner = new Spinner({
    length: 11,
    width: 5,
    radius: 14,
    color: '#000',
    hwaccel: true,
  });

  this.$statusWrap = $('.js-pl-status-wrap'),
  this.$statusSelect = this.$statusWrap.find('.js-pl-location-select'),
  this.$statusMissingWrap = this.$statusWrap.find('.js-status-missing-wrap'),
  this.$statusPanelsWrap = this.$statusWrap.find('.js-pl-status-panels-wrap'),
  this.$statusPanels = this.$statusWrap.find('.js-pl-status-panels'),
  this.$syncedGroupIcon = this.$statusWrap.find('.js-synced-group-icon'),
  this.$processingGroupIcon = this.$statusWrap.find('.js-processing-group-icon'),
  this.$unavailableGroupIcon = this.$statusWrap.find('.js-unavailable-group-icon'),
  this.$syncedGroupCount = this.$statusWrap.find('.js-synced-group-count'),
  this.$processingGroupCount = this.$statusWrap.find('.js-processing-group-count'),
  this.$unavailableGroupCount = this.$statusWrap.find('.js-unavailable-group-count'),
  this.$missingPartnersWrap = this.$statusWrap.find('.js-missing-partners-wrap'),
  this.$iconPointer = this.$statusWrap.find('.js-pl-status-icon-pointer');

  this.listingReport = $('.js-pl-status-panels').html();
  this.missingPartners = $('.js-missing-partners-icons').html();

  // Check that the panel exists (subscription not expired)
  if (this.$statusWrap.length) {
    this.getListingReports();
  }
};

/**
 * Make AJAX call to load own content
 */
PowerListingStatus.prototype.loadListingPanel = function(locationId) {
  var self = this;
  var listingReportUrl = yext.storm.routesDEPRECATED.SmallBusinessOverview.getListingReport();
  if (locationId) {
    listingReportUrl = listingReportUrl + '/' + locationId;
  }

  $.ajax({
    url: listingReportUrl,
    data: {
      showBuySubscriptionButton: this.showBuySubscriptionButton,
      showLocationSelector: this.showLocationSelector,
    },
    success: function(html) {
      self.onLoadListingPanelComplete(html);
    },
  });
};

/**
 * Get listing report (first location if many) and bind all functions related
 * to the status panel.
 */
PowerListingStatus.prototype.getListingReports = function() {
  // If multiple locations
  if (this.$statusSelect.length) {
    this.bindChangeLocationSelect();
  } else {
    this.locationId = $('.js-pl-location-single').val();
  }

  this.bindGroupIcons();

  if (this.listingReport) {
    var $statusGroups = $(this.listingReport);

    this.$statusPanels.html($statusGroups);
    this.setGroupCounts();
    this.bindListingReportTooltips();
    this.bindStatusReportActions();
  }

  this.revealListingElements(this.listingReport, this.missingPartners);
};

/**
 * Binds change event for select element when a business has multiple locations
 *
 * @param {!jQuery} $statusSelect The select element for changing locations
 */
PowerListingStatus.prototype.bindChangeLocationSelect = function($statusSelect) {
  var self = this;
  // Build custom selectbox, this must be called first to generate select
  this.$statusSelect.selectify();

  var $select = this.$statusSelect.find('select');
  this.locationId = $select.val();

  // Changing location
  $select.on('change.powerListingStatus', function() {
    var panelVisible = self.$statusPanelsWrap.is(':visible');

    self.locationId = $select.val();

    if (panelVisible) {
      self.lockHeightClearContentShowLoader();
    }

    self.loadListingPanel(self.locationId);
  });
};

/**
 * Lock the height, clear the contents and show the loader in the status
 * panels container
 */
PowerListingStatus.prototype.lockHeightClearContentShowLoader = function() {
  this.$statusPanels
    .css('height', this.$statusPanels.height())
    .html('');

  this.spinner.spin(this.$statusPanels[0]);
};

/**
 * Binds events having to do do with a new status panel having been loaded
 * along with reseting the selected group icon
 */
PowerListingStatus.prototype.bindEventsResetPanelState = function() {
  this.setGroupCounts();
  this.bindListingReportTooltips();
  this.bindStatusReportActions();
};

/**
 * Bind possible status report actions
 */
PowerListingStatus.prototype.bindStatusReportActions = function() {
  var self = this;

  this.$statusPanels.find('.js-opt-in-listing').click(function() {
    var transitionId = $(this).data('transition-id');

    self.lockHeightClearContentShowLoader();

    optListingIn(transitionId, function(success) {
      if (success) {
        var $statusGroups = $(self.listingReport).hide();
        self.spinner.stop();

        self.$statusPanels.html($statusGroups);
        self.bindEventsResetPanelState();
        self.animateStatusBoxHeight($statusGroups);
      }
    });
  });

  this.$statusPanels.find('.js-reset-listing').click(function() {
    var transitionId = $(this).data('transition-id');

    self.lockHeightClearContentShowLoader();

    optListingOut(transitionId, function(success) {
      if (success) {
        optListingIn(transitionId, function(success) {
          if (success) {
            var $statusGroups = $(self.listingReport).hide();
            self.spinner.stop();

            self.$statusPanels.html($statusGroups);
            self.bindEventsResetPanelState();
            self.animateStatusBoxHeight($statusGroups);
          }
        });
      }
    });
  });
};

/**
 * Binds contextual help tooltips to the partner icons when they are
 * generated
 */
PowerListingStatus.prototype.bindListingReportTooltips = function() {
  this.$statusPanels
    .find('.js-synced-listings .js-pl-report-item')
    .contextualHelp($.extend({}, contextualHelpOptions, {width: 'auto'}));

  this.$statusPanels
    .find('.js-processing-listings .js-pl-report-item, .js-unavailable-listings .js-pl-report-item')
    .contextualHelp($.extend({}, contextualHelpOptions, {width: 180}));
};

/**
 * Shows or hides the status panels and the missing partners elements to
 * measure a target height and then sets them back to their original state
 * and returns the height measured
 *
 * @return {number} Target height used in animation
 */
PowerListingStatus.prototype.measureTargetHeight = function(toggleStatusPanels, toggleMissingPartners) {
  this.$statusPanelsWrap.toggle(toggleStatusPanels);
  this.$missingPartnersWrap.toggle(toggleMissingPartners);
  var targetHeight = this.$statusMissingWrap.height();
  this.$statusPanelsWrap.toggle(!toggleStatusPanels);
  this.$missingPartnersWrap.toggle(!toggleMissingPartners);
  return targetHeight;
};


/**
 * Animates the height of the wrapper around the status panels and the missing
 * partners element and the provides a callback when it is finished
 *
 * @param {number} height Height to animate to
 * @param {function()} callback Function to fire on complete
 */
PowerListingStatus.prototype.animateStatusMissingWrap = function(height, callback) {
  this.$statusMissingWrap.animate({
    height: height,
  }, {
    duration: 600,
    complete: callback,
  });
};

/**
 * Deals with logic around showing and hiding the status panels and the
 * missing partners elements based upon which ones are visible and which ones
 * should be shown or hidden. This has to be curated vs just using the jQuery
 * slideDown method because of height changes based upon the possible
 * combinations of elements showing and hiding and the speed at which the do so
 */
PowerListingStatus.prototype.revealListingElements = function(showListingReport, showMissingPartners) {
  var self = this;
  var statusPanelVisible = this.$statusPanelsWrap.is(':visible');
  var missingPartnersVisible = this.$missingPartnersWrap.is(':visible');

  /**
   * Sets the opacity of an element to 0, slides the element down and then
   * fades its opacity back to 1
   */
  var slideDownAnimateOpacity = function($el) {
    $el
      .css('opacity', 0)
      .slideDown(600, function() {
        $el.animate({opacity: 1});
      });
  };

  if (showListingReport && showMissingPartners) {
    if (!statusPanelVisible && !missingPartnersVisible) {
      var targetHeight = this.measureTargetHeight(true, true);

      this.animateStatusMissingWrap(targetHeight, function() {
        self.$statusPanelsWrap.fadeIn();
        self.$missingPartnersWrap.fadeIn();
        self.$statusMissingWrap.css('height', '');
      });
    } else if (!statusPanelVisible) {
      slideDownAnimateOpacity(this.$statusPanelsWrap);
    } else if (!missingPartnersVisible) {
      slideDownAnimateOpacity(this.$missingPartnersWrap);
    }
  } else if (showListingReport) {
    if (missingPartnersVisible && !statusPanelVisible) {
      var targetHeight = this.measureTargetHeight(true, false);

      this.$missingPartnersWrap.fadeOut(600);

      this.animateStatusMissingWrap(targetHeight, function() {
        self.$statusPanelsWrap.fadeIn();
        self.$statusMissingWrap.css('height', '');
      });
    } else if (statusPanelVisible) {
      this.$missingPartnersWrap.slideUp();
    } else {
      slideDownAnimateOpacity(this.$statusPanelsWrap);
    }
  } else if (showMissingPartners) {
    if (statusPanelVisible) {
      var targetHeight = this.measureTargetHeight(false, true);
      var currentHeight = this.$statusMissingWrap.height();

      this.$statusMissingWrap.css('height', currentHeight);
      this.$statusPanelsWrap.fadeOut(600, function() {
        self.$missingPartnersWrap.fadeIn();
        self.animateStatusMissingWrap(targetHeight, function() {
          self.$statusMissingWrap.css('height', '');
        });
      });
    } else if (!missingPartnersVisible) {
      slideDownAnimateOpacity(this.$missingPartnersWrap);
    }
  }
};

/**
 * Set the number of listings found in each group (synced, processing, unavailable)
 *
 * TODO(mattjs) Logic for which panel to show at first should be moved out of
 * here, but the PowerListingStatus object needs to know the count for each
 * section so this can be done
 */
PowerListingStatus.prototype.setGroupCounts = function() {
  var $syncedListings = this.$statusPanels.find('.js-synced-listings');
  var $processingListings = this.$statusPanels.find('.js-processing-listings');
  var $unavailableListings = this.$statusPanels.find('.js-unavailable-listings');
  var $unavailableListingsItems = $unavailableListings.find('.js-pl-report-item');

  var syncedListingCount = $syncedListings.find('.js-pl-report-item').length;
  var processingListingCount = $processingListings.find('.js-pl-report-item').length;
  var unavailableListingCount = $unavailableListingsItems.length;

  // Choose which panel to show at first
  if (syncedListingCount) {
    $syncedListings.show();
    this.setGroupSelected('synced');
  } else if (processingListingCount) {
    $processingListings.show();
    this.setGroupSelected('processing');
  } else if (unavailableListingCount && this.hasUnavailableNotOptedOut($unavailableListingsItems)) {
    $unavailableListings.show();
    this.setGroupSelected('unavailable');
  } else {
    $syncedListings.show();
    this.setGroupSelected('synced');
  }

  this.$syncedGroupCount.html(syncedListingCount);
  this.$processingGroupCount.html(processingListingCount);
  this.$unavailableGroupCount.html(unavailableListingCount);
};

/**
 * Checks to see if any of the unavaliable are not opted out
 *
 * @param {!jQuery} $unavailableListingsItems Brand icon elements for listings in the unavailable panel
 * @return {boolean} One of the unavailable listings is not opted out
 */
PowerListingStatus.prototype.hasUnavailableNotOptedOut = function($unavailableListingsItems) {
  var hasNotOptedOut = false;

  $unavailableListingsItems.each(function() {
    if (!$(this).data('opted-out')) {
      hasNotOptedOut = true;
      return false; // Breaks from the jQuery each
    }
  });
  return hasNotOptedOut;
};

/**
 * Bind events to switch panels between synced, processing and unavailable
 */
PowerListingStatus.prototype.bindGroupIcons = function() {
  var self = this;

  /**
   * Swaps beteween panels, first checking if it is already visible. Uses name
   * as a string because it has to do a find anyways as the content can change
   * when a business has more than one location
   *
   * @param name Name of the group to swap to (synced, processing, unavailable)
   */
  var swapPanels = function(name) {
    var $panel = self.$statusPanels.find('.'+name+'-listings');
    if (!$panel.is(':visible')) {
      self.setGroupSelected(name);
      self.animateStatusBoxHeight($panel, self.$statusPanels.find('.listing-group:visible'));
    }
  };

  this.$syncedGroupIcon.click(function() {
    swapPanels('synced');
  });

  this.$processingGroupIcon.click(function() {
    swapPanels('processing');
  });

  this.$unavailableGroupIcon.click(function() {
    swapPanels('unavailable');
  });
};

/**
 * Sets the icon for the group 'name' to selected and moves the arrow to point
 * at that icon
 *
 * @param {string} name Name of the group to select (synced, processing, unavailable)
 */
PowerListingStatus.prototype.setGroupSelected = function(name) {
  this.$syncedGroupIcon.removeClass('active-group');
  this.$processingGroupIcon.removeClass('active-group');
  this.$unavailableGroupIcon.removeClass('active-group');

  switch (name) {
    case 'synced':
      this.$syncedGroupIcon.addClass('active-group');
      this.$iconPointer.css('left', 0);
      break;
    case 'processing':
      this.$processingGroupIcon.addClass('active-group');
      this.$iconPointer.css('left', '50%');
      break;
    case 'unavailable':
      this.$unavailableGroupIcon.addClass('active-group');
      this.$iconPointer.css('left', '100%');
      break;
  }
};

/**
 * Animates the height of the power listing status box to transition between
 * the panels and different locations
 */
PowerListingStatus.prototype.animateStatusBoxHeight = function($elementToShow, $elementToHide) {
  var self = this;

  var lockPanelHeight = function() {
    var initialHeight = self.$statusPanels.height();
    self.$statusPanels.css('height', initialHeight);
    return initialHeight;
  };

  var showElement = function(initialHeight) {
    // Calculate target height & set original height afterward
    self.$statusPanels.css('height', '');
    $elementToShow.show();
    var height = self.$statusPanels.height();
    $elementToShow.hide();
    self.$statusPanels.css('height', initialHeight);

    self.$statusPanels.animate({
      height: height,
    }, {
      complete: function() {
        $elementToShow.fadeIn();
        self.$statusPanels.css('height', '');
      },
    });
  };

  if ($elementToHide != undefined) {
    var initialHeight = lockPanelHeight();

    $elementToHide.fadeOut(300, function() {
      showElement(initialHeight);
    });
  } else {
    showElement(lockPanelHeight());
  }
};

var optListingIn = function(transitionId, completeCallback, updateCallback) {
  optListingInOut(transitionId, completeCallback, updateCallback, true);
};

var optListingOut = function(transitionId, completeCallback, updateCallback) {
  optListingInOut(transitionId, completeCallback, updateCallback, false);
};

var optListingInOut = function(transitionId, completeCallback, updateCallback, optIn) {
  $.ajax({
    url: yext.storm.routesDEPRECATED.Listings.transition(),
    data: {ids: transitionId, optIn: optIn},
    type: 'POST',
    success: function(result) {
      setTimeout(function() {
        monitorListingUpdate(result.transitionJobCacheKey, updateCallback, completeCallback);
      }, 1000);
    },
  });
};

var monitorListingUpdate = function(cacheKey, updateCallback, completeCallback) {
  $.ajax({
    url: yext.storm.routesDEPRECATED.Listings.transitionStatus({'cacheKey': cacheKey}),
    dataType: 'json',
    success: function(data) {
      if (data.status == 'DONE') {
        completeCallback(true);
      } else if (data.status == 'FAILED') {
        completeCallback(false);
      } else {
        updateCallback && updateCallback(data);
        setTimeout(function() {
          monitorListingUpdate(cacheKey, updateCallback, completeCallback);
        }, 3000);
      }
    },
  });
};

yext.storm.powerlistingstatus.PowerListingStatus = PowerListingStatus;
